export default __webpack_public_path__ + "static/media/Eraldo Affinati.2ffb00b1.jpg";